export default [
    
    {
    id: "52801",
    name: "Leids Universitair Medisch Centrum (LUMC)",
},

{
    id: "52802",
    name: "Erasmus MC",
}, 

];